import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import _ from 'lodash';
import { captureException } from '@playbookux/playbook-web-core';

import {
  GET_FOLDER_AND_FOLDER_GROUP_BY_COMPANY,
} from '../../graphql/folders';

const useFolders = (companyId) => {
  const {
    loading,
    error,
    data = {},
    refetch,
  } = useQuery(GET_FOLDER_AND_FOLDER_GROUP_BY_COMPANY, {
    variables: {
      companyId,
    },
    fetchPolicy: 'cache-first',
  });

  if (error) {
    captureException('USE_FOLDERS_FAILED', error);
  }
  const { folders = [], folderGroups = [] } = data;

  const groupedFolders = useMemo(() => {
    const foldersGrouped = (_.groupBy(folders, (folder) => folder.folderGroup && folder.folderGroup.id));

    let memoFolder = _.map(folderGroups, (folderGroup) => {
      const groupFolders = _.chain(foldersGrouped)
        .get(folderGroup.id, [])
        .orderBy((v) => v.name.toLowerCase())
        .value();
      return ({
        ...folderGroup,
        key: folderGroup.id,
        folders: groupFolders,
      });
    });

    memoFolder = _.chain(memoFolder)
      .orderBy((v) => v.name.toLowerCase())
      .orderBy('isUngrouped')
      .value();

    return memoFolder || [];
  }, [folderGroups, folders]);

  return {
    groupedFolders,
    refetch,
    error,
    loading,
  };
};

export default useFolders;
